import Template from '../Models/Template';
import DataGridRequest from './DataGridRequest';
export class TemplatesRequest extends DataGridRequest<Template> {
    Url = '/api/v1/templates';
}
